// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__rwptC","text":"NotFound_text__uDJmy","plugsWrapper":"NotFound_plugsWrapper__2brmp"};